import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { API_ROOT } from '@Helpers/apiConfig';
import { createPacerApi } from '@Helpers/pacerApi';
import { parseMutationResponse, MutationResponse } from '../shared.types';
import { type SaveUserColumnsRequest } from './user.types';

// ---- Mutations: User Preferences ----

const saveUserColumns = async (request: SaveUserColumnsRequest): Promise<MutationResponse> => {
    const response = await createPacerApi()
        .put(`${API_ROOT}user/save-columns`, { json: request })
        .json();
    return parseMutationResponse(response);
};

export const useSaveUserColumns = (
    callback?: (result: MutationResponse) => void
): UseMutationResult<MutationResponse, Error, SaveUserColumnsRequest> =>
    useMutation<MutationResponse, Error, SaveUserColumnsRequest>({
        mutationFn: saveUserColumns,
        onSuccess: (result) => callback?.(result),
    });
